import { AxiosResponse } from '@/interface';
import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/interface/store/';
import * as Interface from '@/interface/store/auth';
import * as API from '@/api/auth';
import router from '@/router';

export const actions: ActionTree<Interface.Auth, RootState> = {
  async emailCheck(
    { commit }: ActionContext<Interface.Auth, RootState>,
    email: Interface.EmailPayload
  ) {
    try {
      const { data }: AxiosResponse = await API.emailCheck(email);
      commit('EMAIL_CHECK', data);
    } catch (e) {
      throw e;
    }
  },
  async register(
    { state, commit }: ActionContext<Interface.Auth, RootState>,
    {
      payload,
      inviteMember,
    }: { payload: Interface.RegisterPayload; inviteMember: { code: string; email: string } }
  ) {
    try {
      if (Object.keys(inviteMember).length < 1) {
        const { data }: AxiosResponse = await API.register(payload);
      } else {
        const { data }: AxiosResponse = await API.registerInvite(payload, inviteMember.code);
        await commit('SET_USER', data);
        await commit('IS_REGISTER', null);
        await router.replace({
          name: 'Container',
          params: {
            groupId: state.lastGroupId || 'welcome',
          },
        });
      }
    } catch (e) {
      throw e;
    }
  },
  async login(
    { state, commit }: ActionContext<Interface.Auth, RootState>,
    payload: Interface.LoginPayload
  ) {
    try {
      const { data }: AxiosResponse = await API.login(payload);
      await commit('SET_USER', data);
      await router.replace({
        name: 'Container',
        params: {
          groupId: state.lastGroupId || 'welcome',
        },
      });
    } catch (e) {
      throw e;
    }
  },
  async logOut({ commit }: ActionContext<Interface.Auth, RootState>) {
    try {
      const { data }: AxiosResponse = await API.logout();
      localStorage.removeItem('users');
      commit('LOG_OUT');
      commit('RESET_ALL');
      await router.replace({
        path: '/',
      });
    } catch (e) {
      throw e;
    }
  },
  async forgot({ commit }, payload: Interface.EmailPayload) {
    try {
      const { data }: AxiosResponse = await API.forgot(payload);
    } catch (e) {
      throw e;
    }
  },
  async getForgotPassword({ commit }, code: string) {
    try {
      const { data } = await API.getForgotPassword(code);
    } catch (e) {
      throw e;
    }
  },
  async setForgotPassword({ commit }, payload: { newPassword1: string; newPassword2: string }) {
    try {
      const { data }: AxiosResponse = await API.setForgotPassword(payload);
    } catch (e) {
      throw e;
    }
  },
  async code({ state, commit }: ActionContext<Interface.Auth, RootState>, queryString: string) {
    try {
      const { data }: AxiosResponse = await API.code(queryString);
      await commit('SET_USER', data);
      await router.replace({
        name: 'Container',
        params: {
          groupId: state.lastGroupId || 'welcome',
        },
      });
    } catch (e) {
      throw e;
    }
  },
  async memberInvite({ commit }: ActionContext<Interface.Auth, RootState>, queryString: string) {
    try {
      const { data }: AxiosResponse = await API.memberInvite(queryString);
      if (data.hasOwnProperty('id')) {
        await commit('SET_USER', data);
        await router.replace({
          name: 'Container',
          params: {
            groupId: data.lastGroupId || 'welcome',
          },
        });
      } else {
        localStorage.removeItem('users');
        await commit('IS_REGISTER', data);
        await commit('LOG_OUT');
        await router.replace({
          path: '/',
        });
      }
    } catch (e) {
      throw e;
    }
  },
};
